import gql from 'graphql-tag'

export const GET_USERS = gql`
  query Users($filter: userInputFilter) {
    users(filter: $filter) {
      isSuccessful
      message
      users {
        isPhoneVerified
        isEmailVerified
        phoneNo
        lastLogin
        fullname
        email
        canLogin
        userId
        isEmployee
        isSetPassword
        groups {
          id
          mgroupId
          name
        }
        position {
          name
          unitName
          departmentName
        }
      }
    }
  }
`

export const GET_USER = gql`
  query User($input: GetEmployeeUserInput!) {
    user(input: $input) {
      isSuccessful
      message
      user {
        lastLogin
        fullname
        email
        canLogin
        phoneNo
        userId
        isEmployee
        groups {
          id
          name
        }
        position {
          name
          unitName
          departmentName
        }
      }
    }
  }
`

export const GET_USER_GROUPS = gql`
  query Ugroups {
    ugroups {
      isSuccessful
      message
      ugroups {
        id
        name
      }
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateEmployeeUserInput!) {
    updateUser(input: $input) {
      isSuccessful
      message
      user {
        userId
      }
      status
    }
  }
`
